import React from 'react';

import {ERoles, useGetCurrentUserQuery, useGetTenantDataQuery} from 'src/containers/User';
import {invariant, sendMetrics} from 'src/utils';
import {TSendMetrics} from 'src/utils/sendMetrics';

const useAuthorizedMetrics = () => {
  const {data: user} = useGetCurrentUserQuery();
  const {data: tenant} = useGetTenantDataQuery(undefined, {
    skip: !user || user.roles.includes(ERoles.ROLE_AGENT),
  });

  const tenantId = React.useMemo(() => {
    if (tenant) {
      return tenant.tenantId;
    }

    return user?.tenants?.[0]?.id;
  }, [tenant, user]);

  const handleSendMetrics = React.useCallback(
    (data: TSendMetrics) => {
      invariant('cannot use unauthorized metrics', tenantId !== undefined);

      sendMetrics(data, tenant?.tenantId);
    },
    [tenantId],
  );

  const attachMetrics = React.useCallback(
    (data: TSendMetrics, func?: TAnyFunction) =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (...args: any[]) => {
        handleSendMetrics(data);
        func?.(...args);
      },
    [handleSendMetrics],
  );

  return {sendMetrics: handleSendMetrics, attachMetrics};
};

export {useAuthorizedMetrics};
